import app from 'app';
import ready from 'utils/ready';
import collection from './collection/main';
import sort from './collection/sort';

app.add({
  collection,
  'collection-sort': sort,
});

ready(app.mount);
